/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { addScalarDependencies } from './dependenciesAddScalar.generated';
import { conjDependencies } from './dependenciesConj.generated';
import { multiplyScalarDependencies } from './dependenciesMultiplyScalar.generated';
import { sizeDependencies } from './dependenciesSize.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createDot } from '../../factoriesAny.js';
export var dotDependencies = {
  addScalarDependencies: addScalarDependencies,
  conjDependencies: conjDependencies,
  multiplyScalarDependencies: multiplyScalarDependencies,
  sizeDependencies: sizeDependencies,
  typedDependencies: typedDependencies,
  createDot: createDot
};